import { Instance } from 'mobx-state-tree';
import model from './model';
import actions from './actions';

const User = model.actions(actions);

export interface IUser extends Instance<typeof User> {}

export default User;
